import authReducer from "./auth/reducer";
import signUpReducer from "./formSignUp/reducer";

export default { auth: authReducer, signUp: signUpReducer };
